import { getBetsState } from './betData';

export const getNavSportId = (state, props) => getBetsState(state).navSports[props.fType];
export const getHomeSportId = state => getBetsState(state).navSports.home;
export const getPrematchSportId = state => getBetsState(state).navSports.prematch;
export const getLiveSportId = state => getBetsState(state).navSports.live;
